export enum BrandNameList {
  FE = 'FE',
  LC = 'LC',
  TO = 'TO',
}

export enum BrandNameLabelList {
  FE = 'Foreyes',
  LC = 'Lenscrafters',
  TO = 'Target Optical',
}
